import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppTranslateService } from '../../../../core/services/app.translate.service';
import { GeneralButtonComponent } from '../general-button/general-button.component';
import { GeneralIconButtonComponent } from '../general-icon-button/general-icon-button.component';
import { TranslatePipe } from '@ngx-translate/core';

export type IModalType = 'danger' | 'warning' | 'info';
export interface IConfirmDialogComponentData {
  title: string;
  description: string;
  cancelBtnName: string;
  confirmBtnName: string;
  type?: IModalType;
}

@Component({
  selector: 'app-confirm-dialog',
  imports: [TranslatePipe, GeneralIconButtonComponent, GeneralButtonComponent],
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.scss',
})
export class ConfirmDialogComponent {
  readonly dialogRef: MatDialogRef<ConfirmDialogComponent, boolean> = inject(MatDialogRef<ConfirmDialogComponent, boolean>);
  readonly data: IConfirmDialogComponentData = inject<IConfirmDialogComponentData>(MAT_DIALOG_DATA);
  readonly appTranslate = inject(AppTranslateService);
}
